import styled from "styled-components";

import { SearchBillingDataStyledProps as Props } from "./SearchBillingData.types";

const SearchBillingDataStyled = styled.div<Props>`
  .SearchBillingData {
    &__search-bar {
      width: 100%;
      display: flex;
      align-items: center;
      background-color: var(--palette-black-s2-l21);
      border-radius: 0.8rem;
      margin-bottom: 1.6rem;
    }

    &__icon {
      padding: 0 0.8rem;
      display: flex;
      margin-left: 0.8rem;

      path {
        fill: var(--palette-white);
      }
    }

    &__text-input {
      input {
        border: none;

        &.TextInput__input {
          background-color: var(--palette-black-s2-l21);
          padding: 0.8rem 10.8rem 0.8rem 1.6rem;
          color: var(--palette-white);
          font-size: 1.6rem;
          height: 4.2rem;
          border-radius: 10rem;

          &:hover:not([disabled]) {
            border: none;
          }

          &:focus {
            box-shadow: none;
          }
        }
      }
    }

    &__title {
      color: var(--palette-black-s0-l10);
    }
  }
`;

export default SearchBillingDataStyled;
